import { css } from 'styled-components';

export const SunsetGlowSkin = css`
  background-color: #ff7e5f;
  border: 2px solid #feb47b;
  box-shadow: 0 0 10px #ff7e5f;
`;

export const SunsetGlowWrapperSkin = css`
  background: linear-gradient(90deg, #ff7e5f 0%, #feb47b 100%);
`;

export const SunsetGlowLetterSkin = css<{ $isActive: boolean }>`
  color: ${props => (props.$isActive ? '#fff' : '#552200')};
  opacity: ${props => (props.$isActive ? 1 : 0.2)};
`;
